import React from 'react';
import styled from 'styled-components';
import { validationStrings } from '/imports/strings';
import { css } from '/imports/ui/css';

const FormErrorStyled = styled.div`
  padding: 0 0.5rem;
  color: ${css.red2};
  border-left: 3px solid ${css.red2};
`;

interface FormErrorProps {
  field: string,
  error?: any
}

/** Renders a styled validation error message for a given form field, if any. */
export const FormError = (props: FormErrorProps) => {
  const { field, error } = props;
  const errorString = (validationStrings as any)[error?.[field]?.[0]]?.() || error?.[field]?.[0];
  if (!errorString) return null;
  return (
    <FormErrorStyled className="error">
      {errorString}
    </FormErrorStyled>
  );
};